<template>
    <div class="card">
      <input
      type="checkbox"
      :checked="isSelected"
      @change="toggleCheckbox"
      class="article-checkbox"
    />
    <img :src="`/storage/${article.image_article}`" alt="Image de l'article" class="card-img" />
    <!-- <img :src="`https://imbz-mirindra.tms.mg/${article.image_article}`" alt="Image de l'article" class="card-img"  @error="(e) => console.error('Image introuvable :', e.target.src)"/> -->


      <div class="card-content">
        <h3 class="card-title">{{ article.nom_article }}</h3>
        <p class="card-description">{{ article.description_article }}</p>
        <p class="card-quantity">Quantité : {{ article.quantite_disponible }}</p>
        <h5 class="card-quantity" style="text-align: right;" >{{ formatNumber(article.prix) }} Ariary</h5>

        <!-- <button @click="$emit('edit', article)" class="edit-btn">Modifier</button> -->
      </div>
    </div>
  </template>
  
  <script>
  export default {
  name: 'ArticleCard',
  props: {
    article: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    toggleCheckbox() {
      this.$emit('toggle-select', this.article.id);
    },
    formatNumber(num) {
      return Number(num).toLocaleString('fr-FR');
    },
  },
  mounted() {
    console.log('Image article :', this.article.image_article);
  }
};

  </script>
  
  <style scoped>
  .card {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: transform 0.3s ease;
    max-width: 300px;
    margin: 10px;
  }

  .article-checkbox {
  margin-top: 10px;
  cursor: pointer;
}
  
  .card:hover {
    transform: translateY(-5px);
  }
  
  .card-img {
    width: 100%;
    height: 200px;
    object-fit: cover;
  }
  
  .card-content {
    padding: 15px;
  }
  
  .card-title {
    font-size: 1.5rem;
    color: #007BFF;
    margin-bottom: 10px;
  }
  
  .card-description {
    font-size: 1rem;
    color: #555;
    margin-bottom: 15px;
  }
  
  .card-quantity {
    font-size: 1rem;
    color: #888;
  }

  .edit-btn {
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background-color: #7160ce;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.edit-btn:hover {
  background-color: #5a48b0;
}
  </style>
  